import { Tabs as ChakraTabs, TabsProps as ChakraTabsProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { InferPropTypes } from '../../types';

export const sizePropTypes = ['sm', 'md', 'lg'];
export const variantPropTypes = ['line', 'enclosed'];
export const alignPropTypes = ['start', 'center', 'end'];

const propTypes = {
  align: PropTypes.oneOf(alignPropTypes),
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(sizePropTypes),
  isLazy: PropTypes.bool,
  isFitted: PropTypes.bool,
  variant: PropTypes.oneOf(variantPropTypes)
};
const defaultProps = {
  align: 'start',
  size: 'md',
  isLazy: true,
  isFitted: false,
  variant: 'line'
};

type InheritProps = Omit<ChakraTabsProps, 'orientation'>;
export type TabsProps = InheritProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

const Tabs = (props: TabsProps): React.ReactElement => {
  const baseProps: Partial<ChakraTabsProps> = {
    orientation: 'horizontal'
  };

  return <ChakraTabs {...baseProps} {...props} />;
};

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

export default Tabs;
